export const PRODUCTS = {
  '00026': { code: '00026', name: 'Refeição (OFF)', color: '#FF7700' },
  '00027': { code: '00027', name: 'Alimentação', color: '#DF1683' },
  '00028': { code: '00028', name: 'Auto', color: '#636569' },
  '00030': { code: '00030', name: 'Cultura', color: '#0072CE' },
  '00031': { code: '00031', name: 'Refeição', color: '#FF7700' },
  '00032': { code: '00032', name: 'Multi Alimentação', color: '#00AA13' },
  '00033': {
    code: '00033',
    name: 'Multi Alimentação Cesta Básica',
    color: '#00AA13',
  },
  '00034': { code: '00034', name: 'Cartão da Mamãe', color: '#00AA13' },
  '00035': { code: '00035', name: 'Multi Cash', color: '#00AA13' },
  '00036': { code: '00036', name: 'Multi Cash Natal', color: '#00AA13' },
  '00037': { code: '00037', name: 'Multi Cash Eletro', color: '#00AA13' },
  '00038': { code: '00038', name: 'Multi Store', color: '#00AA13' },
  '00049': { code: '00049', name: 'Multi Refeição', color: '#00AA13' },
  '00051': { code: '00051', name: 'Sazonal', color: '#00AA13' },
  '00201': { code: '00201', name: 'Cesta', color: '#00AA13' },
  '00202': { code: '00202', name: 'Boas Festas', color: '#C2AA6A' },
  '00203': { code: '00203', name: 'Compras', color: '#C6007E' },
  '00204': { code: '00204', name: 'Auxílio Alimentação', color: '#00AA13' },
  '00205': { code: '00205', name: 'Saúde', color: '#00B2E3' },
  '00207': { code: '00207', name: 'Multibenefícios', color: '#6A7F96' },
  '00209': { code: '00209', name: 'VR+VA', color: '#33C5C5' },
  '00241': { code: '00241', name: 'Contraternização', color: '#00AA13' },
  '00242': { code: '00242', name: 'Refeição Adicional', color: '#00AA13' },
  '00243': { code: '00243', name: 'Auxílio Refeição', color: '#00AA13' },
  '00261': { code: '00261', name: 'VR Manutenção', color: '#00AA13' },
  '00270': { code: '00270', name: 'Refeição', color: '#F89520' },
  '00290': { code: '00290', name: 'Alimentação', color: '#FE0080' },
  '00401': { code: '00401', name: 'Multi Cheque', color: '#00AA13' },
  '00402': { code: '00402', name: 'Multi Empresarial', color: '#00AA13' },
  '00403': { code: '00403', name: 'Multi Combustível', color: '#00AA13' },
  '99999': { code: '99999', name: 'Transporte', color: '#00AA13' },
};

export const GOOGLE_MAPS_KEY = 'AIzaSyA8E2ohT2qNyk4kBb5pbmNSp_GC6o6fORs';
export const JVCEF = 'JVCEF';
export const VRPAT = 'VRPAT';
export const DELIVERY_COLORS = {
  ifood: ' #ED1722',
  rappi: ' #FD6250',
  ubereats: '#06C167;',
};
